<template>
  <div class="mult-input-intro">
    <div class="text van-multi-ellipsis--l2" v-if="showList.text.length > 0 && !$slots.title">
      {{ showList.text[0].content }}     
    </div>    
    <div class="text van-multi-ellipsis--l2" v-if="$slots.title">
      <slot name="title"></slot>
    </div>

    <template v-if="showMulti && showList.other.length > 0">
      <div class="wrap">
        <template v-for="(other, index) in showList.other">
          <template v-if="index < 3">
            <div class="box-out" :key="index">
              <div
                v-if="other.type == 'image'"
                class="box bg-cover"
                :style="`background-image: url('${other.url}');`"
              ></div>

              <div v-else-if="other.type == 'audio'" class="box audio">
                <van-icon class-prefix="vxs-icon" name="yuyin" size="18" color="#FFF" />
              </div>

              <!-- 视频缩略展示 -->
              <div
                v-else-if="other.type == 'video'"
                class="box bg-cover video"
                :style="`background-image: url('${getVideoThumbUrl(other)}');`"
              >
                <!-- <van-icon class-prefix="vxs-icon" name="shipin" size="18" color="#FFF" /> -->
                <div class="to-play-icon"></div>
              </div>

              <!-- 精彩瞬间展示 西瓜视频 -->
              <template v-else-if="other.type === 'moment'">
                <!-- status: 1合成中，2合成成功，3合成失败 -->
                <!-- 已经有视频的url地址 -->
                <div
                  v-if="other.url || other.status == 2"
                  class="box bg-cover video"
                  :style="`background-image: url('${getVideoThumbUrl(other)}');`"
                >
                  <!-- <van-icon class-prefix="vxs-icon" name="shipin" size="18" color="#FFF" /> -->
                  <div class="to-play-icon"></div>
                </div>
                <!-- 一键生成视频or合成中视频：暂无视频的url地址 -->
                <div class="box bg-cover video-default" v-else-if="other.status == 1">
                  <van-loading color="var(--c1)" size="18" />
                </div>
                <!-- 一键生成视频or合成中视频：合成失败 -->
                <div class="box bg-cover video-default" v-else-if="other.status == 3">
                  <van-icon name="warning-o" class="warn" size="18" />
                </div>
              </template>

              <div class="is-more" v-if="index == 2 && showList.other.length > 3">更多</div>
            </div>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    //   接一传入数据
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 是否展示多媒体信息
    showMulti: {
      type: Boolean,
      default: true,
    },    
  },
  computed: {
    showList() {
      let obj = {
        text: [],
        other: [],
      };
      this.list.forEach((item, key) => {
        if (['aitext','text'].includes(item.type) && item.content) {
          obj.text.push(item);
        } else if (item.type != 'text') {
          obj.other.push(item);
        }
      });

      return obj;
    },
  },
  methods: {
    // 获取视频封面图
    getVideoThumbUrl(item) {
      return item.thumburl || `${item.url}?x-oss-process=video/snapshot,t_1,f_jpg,w_1000,ar_auto`;
    },
  },
};
</script>

<style lang="scss" scoped>
.mult-input-intro {
  padding: calc(var(--gap) * 8) 0;
  .text {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    color: var(--g8);
  }
  .wrap {
    display: flex;
    .box-out {
      position: relative;
      margin: calc(var(--gap) * 8) calc(var(--gap) * 8) 0 0;
      width: calc(var(--w) * 48);
      height: calc(var(--w) * 48);
      border-radius: var(--radius-base);
      overflow: hidden;
    }
    .box {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      &.audio {
        background: var(--c1);
      }
      &.video-default {
        background-color: #f5f5f5;
        .warn {
          color: var(--c3);
        }
      }
      .to-play-icon {
        width: calc(var(--gap) * 18);
        height: calc(var(--gap) * 18);
      }
    }
    .is-more {
      position: absolute;
      z-index: 2;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background: var(--black);
      opacity: 0.6;
      color: var(--white);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>